import {useQuery} from '@tanstack/react-query'
import dayjs from 'dayjs'
import {FC} from 'react'
import {Link, useParams} from 'react-router-dom'
import {truncateString} from '../../../_component/CustomFunctions'
import {QUERIES} from '../../../_metronic/helpers'
import {News} from '../../modules/apps/news/news-list/core/_models'
import {getNews, getNewsById} from '../../modules/apps/news/news-list/core/_requests'
import {fileSrc} from '../../../_component/fileUtils'

export const AnnouncementDetailsPage: FC = () => {
  const {id} = useParams()

  const {data: announcement} = useQuery(
    [`${QUERIES.ANNOUNCEMENTS_LIST}`, id],
    () => {
      return getNewsById(id)
    },
    {
      cacheTime: Infinity,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !!id,
    }
  )
  const {data: announcements} = useQuery(
    [`${QUERIES.ANNOUNCEMENTS_LIST}`],
    () => {
      return getNews(`page_size=3&filter={"is_view_on_web":true,"status":true}`)
    },
    {
      cacheTime: Infinity,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  )
  return (
    <div id='kt_app_content' className='app-content flex-column-fluid'>
      {/*begin::Content container*/}
      <div id='kt_app_content_container' className='app-container container-xxl'>
        {/*begin::About card*/}
        <div className='card'>
          {/*begin::Body*/}
          <div className='card-body p-lg-17'>
            {/*begin::About*/}
            <div className='mb-18'>
              {/*begin::Wrapper*/}
              <div className='mb-10'>
                {/*begin::Top*/}
                <div className='text-center mb-15'>
                  {/*begin::Title*/}
                  <h3 className='fs-2hx text-dark mb-5'>{announcement?.title}</h3>
                  {/*end::Title*/}
                </div>
                {/*end::Top*/}
                {/*begin::Overlay*/}
                <div className='overlay'>
                  {/*begin::Image*/}
                  <img
                    className='w-100 card-rounded'
                    src={announcement?.image ? fileSrc(announcement?.image) : ''}
                    alt=''
                  />
                  {/*end::Image*/}
                </div>
                {/*end::Container*/}
              </div>
              {/*end::Wrapper*/}
              {/*begin::Description*/}
              <div className='fs-5 fw-semibold text-gray-600'>
                {/*begin::Text*/}
                <p
                  className='mb-8'
                  dangerouslySetInnerHTML={{__html: announcement?.description || ''}}
                ></p>
                {/*end::Text*/}
              </div>
              {/*end::Description*/}
            </div>
            {/*end::About*/}
            {/*begin::Statistics*/}
            <div className='card bg-light mb-18'>
              {/*begin::Body*/}
              <div className='card-body py-15'>
                {/*begin::Top*/}
                <div className='text-center mb-12'>
                  {/*begin::Title*/}
                  <h3 className='fs-2hx text-dark mb-5'>Recent Announcements</h3>
                  {/*end::Title*/}
                </div>
                {/*end::Top*/}
                {/*begin::Row*/}
                <div className='row g-10'>
                  {/*begin::Col*/}
                  {announcements?.entities?.map((entity: News) => (
                    <div className='col-md-4' key={entity.id}>
                      {/*begin::Publications post*/}
                      <div className='card-xl-stretch me-md-6'>
                        {/*begin::Overlay*/}
                        <a
                          className='d-block overlay mb-4'
                          data-fslightbox='lightbox-hot-sales'
                          href={entity.image ? fileSrc(entity.image) : ''}
                          target='_blank'
                          rel='noreferrer'
                        >
                          {/*begin::Image*/}
                          <div
                            className='overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-contain card-rounded min-h-175px'
                            style={{
                              backgroundImage: `url(${entity.image ? fileSrc(entity.image) : ''})`,
                            }}
                          ></div>
                          {/*end::Image*/}
                          {/*begin::Action*/}
                          <div className='overlay-layer bg-dark card-rounded bg-opacity-25'>
                            <i className='bi bi-eye-fill fs-2x text-white'></i>
                          </div>
                          {/*end::Action*/}
                        </a>
                        {/*end::Overlay*/}
                        {/*begin::Body*/}
                        <div className='m-0'>
                          {/*begin::Title*/}
                          <Link
                            to={`/web/announcement/${entity.id}`}
                            className='fs-4 text-dark fw-bold text-hover-primary text-dark lh-base'
                          >
                            {entity.title}
                          </Link>
                          {/*end::Title*/}
                          {/*begin::Text*/}
                          <div
                            className='fw-semibold fs-5 text-gray-600 text-dark mt-3 mb-5'
                            dangerouslySetInnerHTML={{
                              __html: truncateString(entity.description, 100),
                            }}
                          ></div>
                          {/*end::Text*/}
                          {/*begin::Content*/}
                          <div className='fs-6 fw-bold'>
                            {/*begin::Author*/}
                            <span
                              // href='../../demo1/dist/apps/projects/users.html'
                              className='text-gray-700 text-hover-primary'
                            >
                              {entity.account?.user?.name}
                            </span>
                            {/*end::Author*/}
                            {/*begin::Date*/}
                            <span className='text-muted'>
                              {' '}
                              on {dayjs(entity.created_at).format('MMM DD YYYY')}
                            </span>
                            {/*end::Date*/}
                          </div>
                          {/*end::Content*/}
                        </div>
                        {/*end::Body*/}
                      </div>
                      {/*end::Publications post*/}
                    </div>
                  ))}
                  {/*end::Col*/}
                </div>
                {/*end::Row*/}
              </div>
              {/*end::Body*/}
            </div>
            {/*end::Statistics*/}
          </div>
          {/*end::Body*/}
        </div>
        {/*end::About card*/}
      </div>
      {/*end::Content container*/}
    </div>
  )
}
